import { render } from "./DiscussionPreview.vue?vue&type=template&id=62041c6e"
import script from "./DiscussionPreview.vue?vue&type=script&lang=js"
export * from "./DiscussionPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__